import { useCartActionFragment$data } from '__generated__/useCartActionFragment.graphql';
import { Segment } from 'shared/hooks';

interface FilterSegmentAccountsParameter {
  accountList: useCartActionFragment$data['me']['accountList'];
  segment: Segment;
}

export function filterSegmentAccounts({
  accountList,
  segment,
}: FilterSegmentAccountsParameter): useCartActionFragment$data['me']['accountList'] {
  return accountList.filter(
    (account) =>
      account.balanceManagement === 'POSTPAID' && account.segment === segment,
  );
}
